import React from 'react';
import Testimonials from '../components/Testimonials/Testimonials';
import WhatsAppButton from '../components/WhatsAppButton/WhatsAppButton';
import './TestimonialsPage.css';

/**
 * Page Témoignages - Page dédiée aux témoignages clients
 */
function TestimonialsPage() {
  return (
    <div className="testimonials-page">
      <div className="testimonials-page-header">
        <div className="container">
          <div
            className="page-header-banner"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/female2.png)`,
            }}
          >
            <h1 className="page-title">Témoignages</h1>
            <p className="page-subtitle">
              Découvrez ce que nos clients disent de leur expérience avec Wote
            </p>
          </div>
        </div>
      </div>

      <Testimonials />

      <section className="testimonials-cta">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Rejoignez nos clients satisfaits</h2>
            <p className="cta-description">
              Contactez-nous pour commencer votre projet avec Wote
            </p>
            <WhatsAppButton />
          </div>
        </div>
      </section>
    </div>
  );
}

export default TestimonialsPage;

